import axios from "axios";
import moment from 'moment/moment';

export default {

    $btnSubmitCoupon: null,
    $formSubmitCoupon: null,
    $inputCoupon: null,
    $inputsQty:null,
    $cartSubtotal: null,
    $cartSubtotalNoCoupon: null,
    $cartTax: null,
    $cartTotal: null,
    $cartCouponCode: null,
    $cartCouponIsRemovingFlag: null,
    $cartActions: null,
    $countdownContainer: null,
    $checkoutStatus: null,
    $checkoutSubmit: null,
    $formNexi: null,
    $formNexiSubmit: null,

    init() {

        this.$btnSubmitCoupon = $('#coupon-form button');
        this.$formSubmitCoupon = $('#coupon-form');
        this.$inputCoupon = $('input[name="coupon"]');
        this.$inputsQty = $('.main-cart-container').find('input[type="number"]');
        this.$cartSubtotal = $('.cart-subtotal');
        this.$cartSubtotalNoCoupon = $('.cart-subtotal-no-coupon');
        this.$cartTax = $('.cart-tax');
        this.$cartTotal = $('.cart-total');
        this.$cartCouponCode = $('.cart-coupon-code');
        this.$cartCouponIsRemovingFlag = $('input[name="is_removing"]');
        this.$cartActions = $('.cart .actions');
        this.$countdownContainer = $('.cart .countdown-container');
        this.$checkoutStatus = $('.cart .checkout-status');
        this.$checkoutSubmit = $('.cart .btn-primary');

        this.$formNexi = $('#form-nexi');
        this.$formNexiSubmit = $('#form-nexi .submit-nexi');

      
        console.log(this.$cartTax.text())
        // JavaScript to be fired on the checkout page
        this.autoFillAddresses('shipping','shippingAddresses', 'shipping_addresses');


        /**************************************************/
        // input qty
        /**************************************************/

        $("[name^=qty-]").keydown(function (e) {
            e.preventDefault();
        });

        const $inputQtyAdd = $('.input-quantity .input-group-prepend');
        const $inputQtyMin = $('.input-quantity .input-group-append');

        const CancelToken = axios.CancelToken;
        let cancel;
        let postRequest;

        $inputQtyAdd.on('click', e => {
            e.stopImmediatePropagation();

            let $inputNumber = $(e.currentTarget).parent('.input-quantity').find('input[type="number"]');

            if(parseInt($inputNumber.val(), 10) >= parseInt($inputNumber.attr('max'), 10) ) {
                return;
            }

            // cancel double request
            if(postRequest) {
                postRequest[1]();
            }

            let nextInputVal = parseInt($inputNumber.val()) + 1;
            $inputNumber.val( parseInt(nextInputVal));
            this.checkButtons(nextInputVal, e.currentTarget);
            postRequest = this.updateCart(CancelToken, cancel);
        });

        $inputQtyMin.on('click', e => {
            e.stopImmediatePropagation();
            let $inputNumber = $(e.currentTarget).parent('.input-quantity').find('input[type="number"]');

            if(parseInt($inputNumber.val(), 10) <= parseInt($inputNumber.attr('min'), 10) ) {
                return;
            }

            // cancel double request
            if(postRequest) {
                postRequest[1]();
            }

            let nextInputVal = parseInt($inputNumber.val()) - 1;
            $inputNumber.val(nextInputVal);
            this.checkButtons(nextInputVal, e.currentTarget);
            postRequest = this.updateCart(CancelToken, cancel);

        });

        /**************************************************/
        // delete cart row
        /**************************************************/
        const $deleteRow = $('.delete-cart-row');
        const CancelTokenDeleteRow = axios.CancelToken;
        let cancelDeleteRow;
        let postRequestDelete;

        $deleteRow.on('click', e => {
            e.preventDefault();
            const productId = $(e.currentTarget).data('product');

            if(postRequestDelete) {
                postRequestDelete[1]();
            }

            let $products = $('.main-cart-container .main .product:visible');
            let showNoProductsTitle = false;

            if($products.length === 1) {
                showNoProductsTitle = true;
                this.$cartActions.addClass('d-none');
                this.$countdownContainer.addClass('d-none');
            }

            $(e.currentTarget).parents('.product').fadeOut('fast', () => {

                if(showNoProductsTitle) {
                    $('.main-cart-container .main > h3').removeClass('d-none');
                    this.$inputCoupon.val('');
                    this.$btnSubmitCoupon.html(window.CART.coupon_submit);
                    this.$cartCouponIsRemovingFlag.val(0);
                }
            });

            postRequestDelete = this.deleteCartRow(productId, CancelTokenDeleteRow, cancelDeleteRow, this.errorOnDeleteCartRow, this.updateFields);

        });

        /**************************************************/
        // submit order
        /**************************************************/

        const $btnSubmitOrder = $('.btn-submit-order');
        const $formSubmitOrder = $('#form-order-submit');

        let isFormOrderSumbitting = false;
        $btnSubmitOrder.on('click', e => {
            e.preventDefault();
            if(isFormOrderSumbitting) return;

            isFormOrderSumbitting = true;
            $formSubmitOrder.submit();
        });

        /**************************************************/
        // submit coupon
        /**************************************************/

        let isFormCouponSumbitting = false;
        this.$formSubmitCoupon.on('submit', e => {
            e.preventDefault();
            if(isFormCouponSumbitting) return;

            isFormCouponSumbitting = true;
            this.$btnSubmitCoupon.attr('disabled', true);

            let formData = this.$formSubmitCoupon.serialize();

            axios.post(window.CART.applyCoupon, formData)
                .then( (response) => {
                    if(response.status === 200 ) {

                        if(response.data.applied === 0) {
                            this.$inputCoupon.attr('data-original-title', window.CART.coupon_not_found);
                            this.$inputCoupon.tooltip("show");
                            setTimeout(() => {
                                this.$inputCoupon.tooltip("hide");
                            }, 4000);
                        } else if(response.data.applied === 1) {
                            this.updateFields(response);
                            this.$btnSubmitCoupon.html(window.CART.coupon_delete);
                            this.$cartCouponIsRemovingFlag.val(1);
                        } else {
                            this.updateFields(response);
                            this.$inputCoupon.val('');
                            this.$btnSubmitCoupon.html(window.CART.coupon_submit);
                            this.$cartCouponIsRemovingFlag.val(0);
                        }

                    } else {
                        this.errorOnUpdateCart();
                    }
            })
            .catch( (error) => {
                console.log(error);
                this.errorOnUpdateCart();
            })
            .then( () => {
                // always executed
                this.$btnSubmitCoupon.attr('disabled', false);
                isFormCouponSumbitting = false;
            })

        });


        /**************************************************/
        // cart countdown
        /**************************************************/

        let eventTime = parseInt(window.CART.cart_ends, 10);
        let currentTime = parseInt(window.CART.cart_now_ts, 10);
        let diffTime = eventTime - currentTime;
        let duration = moment.duration(diffTime*1000, 'milliseconds');
        let interval = 1000;

        setInterval(() => {
            duration = moment.duration(duration - interval, 'milliseconds');

            if(duration.days() > 0) {
                this.$countdownContainer.find('.countdown').html(duration.days() + ' ' + window.CART.days + ' ' + window.CART.and + ' ' + duration.hours() + ' ' + window.CART.hours);
            } else if(duration.days() === 0 && duration.hours() > 0) {
                this.$countdownContainer.find('.countdown').html(duration.hours() + ' '+ window.CART.hours + ' ' + window.CART.and + ' ' + duration.minutes() + ' ' + window.CART.minutes);
            } else if(duration.days() === 0 && duration.hours() === 0) {
                this.$countdownContainer.find('.countdown').html(duration.minutes() + ' '+ window.CART.minutes + ' ' + window.CART.and + ' ' + duration.seconds() + ' ' + window.CART.seconds);
            }

        }, interval);


        /**************************************************/
        // submit nexi form
        /**************************************************/

        let formNexiSubmitting = false;
        this.$formNexiSubmit.on('click', e => {
            e.preventDefault();

            if(formNexiSubmitting) {
                return
            }

            formNexiSubmitting = true;


            const $products = $('.main-cart-container .product');

            const products = [];

            for(let i = 0; i < $products.length; i++) {
                const tmp = {};

                tmp['cart_row_id'] = $($products[i]).data('cart-row-id');
                tmp['product_id'] = $($products[i]).data('product-id');
                tmp['qty'] = $($products[i]).data('qty');
                products.push(tmp);
            }

            const codTrans = $('input[name="codTrans"]').val();

            axios.post(window.CART.cartCheck, {
                products: products,
                cart_id: codTrans.split("||")[0],
            }).then( (response) => {

                    if(response.status === 200) {
                        if(response.data) {
                            this.$formNexi.submit();
                        } else {
                            window.location = window.location;
                        }

                    } else {
                        this.errorOnCheckCart();
                    }

                })
                .catch( (error) => {
                    console.log(error);
                    this.errorOnCheckCart();
                })
                .then( () => {
                    // always executed
                    formNexiSubmitting = false;
                });
        });

    },
    finalize() {
        // JavaScript to be fired on the home page, after the init function

    },

    updateCart(CancelToken, cancel) {

        let products = [];
        for ( let i = 0; i < this.$inputsQty.length; i++) {
            let id = $(this.$inputsQty[i]).attr('id').replace('qty-','');
            products.push({ id: id, qty: $(this.$inputsQty[i]).val() })
        }

        return [ axios.post(window.CART.update, products, {
            cancelToken: new CancelToken( c => {
                // An executor function receives a cancel function as a parameter
                cancel = c;
            })
        }).then( response => {
            if(response.status === 200) {
                this.updateFields(response);
            } else {
                this.errorOnUpdateCart();
            }

        })
        .catch( error => {
            console.log(error);
            this.errorOnUpdateCart();
        })
        .then(() => {
            // always executed
        }), cancel];

    },

    deleteCartRow(productId, CancelTokenDeleteRow, cancelDeleteRow) {

        return [axios.post(window.CART.deleteRow, { id: productId },{
            cancelToken: new CancelTokenDeleteRow( c => {
                // An executor function receives a cancel function as a parameter
                cancelDeleteRow = c;
            })
        })
        .then( (response) => {

            if(response.status === 200) {
                this.updateTax();
                this.updateFields(response);

            } else {
                this.errorOnDeleteCartRow();
            }

        })
        .catch( (error) => {
            console.log(error);
            this.errorOnDeleteCartRow();
        })
        .then( () => {
            // always executed
        }), cancelDeleteRow];
    },
    updateTax(){
        axios.post(window.CART.updateTax)
        .then(() => {
          
                console.log('tax update');
    
        })
    },
    errorOnUpdateCart() {
        // TODO handle error update cart
    },

    errorOnDeleteCartRow() {
        // TODO handle error on delete cart row
    },

    errorOnCheckCart() {
        // TODO handle error update cart
    },

    checkButtons(inputVal, target) {
        const $target = $(target);
        const $qty = $target.parents('.qty');
        const max = parseInt($qty.find('input').attr('max'), 10);

        if( parseInt($qty.find('input').val(), 10) === 1) {
            $qty.find('.input-group-append .input-group-text').addClass('--input-deactivated');
        } else {
            $qty.find('.input-group-append .input-group-text').removeClass('--input-deactivated');
        }

        if( parseInt($qty.find('input').val(), 10) === max ) {
            $qty.find('.input-group-prepend .input-group-text').addClass('--input-deactivated');
        } else {
            $qty.find('.input-group-prepend .input-group-text').removeClass('--input-deactivated');
        }

    },

    updateFields(response) {
        let products = response.data.products;
        let cart = response.data.cart;
    
        for ( let i = 0; i < this.$inputsQty.length; i++) {
            let productUpdated = products.find( ele => ele.id === parseInt($(this.$inputsQty[i]).attr('id').replace('qty-',''), 10) );

            if (productUpdated) {
                $(this.$inputsQty[i]).val(productUpdated.qty).attr('max', productUpdated.max_qty);
                this.checkButtons(productUpdated.qty, this.$inputsQty[i]);
                $('.subtotal[data-product="'+productUpdated.id+'"]').html(productUpdated.subtotal);
            }
        }

        this.$cartSubtotal.html(cart.subtotal_no_coupon ? cart.subtotal_no_coupon : cart.subtotal);
        this.$cartTax.html(cart.tax);
        this.$cartTotal.html(cart.total);
        if(cart.subtotal_no_coupon !== undefined) {
            this.$cartCouponCode.parents('div').removeClass('d-none');
            this.$cartCouponCode.html(cart.coupon_code);
            this.$cartSubtotalNoCoupon.html(cart.subtotal_discount);
        } else {
            this.$cartCouponCode.closest('div').addClass('d-none');
        }

        if(cart.checkout_enabled) {
            this.$checkoutSubmit.removeClass('d-none');
            this.$checkoutStatus.addClass('d-none');
        } else {
            this.$checkoutSubmit.addClass('d-none');
            this.$checkoutStatus.removeClass('d-none');
        }

        $(window).trigger('updateCartContent', [cart.count]);
         window.location.reload();
    },

    autoFillAddresses(prefix, jsonElementId, selectId) {

        const jsonElement =  $('#' + jsonElementId);

        if (jsonElement.length === 0) {
            return;
        }

        const adresses = JSON.parse(jsonElement.html());
        const $select = $('#' + selectId);

        $select.on('change', e => {
            const arrIndex = parseInt($(e.currentTarget).val(), 10);

            if (arrIndex !== 'new_address') {
                let address = adresses.find( ele => ele.id === arrIndex );
                const keys = Object.keys(address);

                //autofill
                for (let i = 0; i < keys.length; i++) {
                    $('#' + keys[i]).val(address[keys[i]]);
                }
            } else {
                //clear all fieldset fields
                $(e.currentTarget).parents('.collapse').find('input, select').val('');
            }

        });
    },
};
